export default "__VITE_ASSET__DFTealUg__"